import { render, staticRenderFns } from "./measure.vue?vue&type=template&id=0b94a67c&scoped=true&"
import script from "./measure.vue?vue&type=script&lang=js&"
export * from "./measure.vue?vue&type=script&lang=js&"
import style0 from "./measure.vue?vue&type=style&index=0&id=0b94a67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94a67c",
  null
  
)

export default component.exports